<template>
	<div class="head-title">
		<span>{{title}}</span>
		<div class="head-title-right">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ep-title',
		props: {
			title: {
				type: String,
				default: '标题'
			}
		}
	}
</script>

<style scoped>
	.head-title {
		line-height: 50px;
		box-sizing: border-box;
		text-align: left;
		border-bottom: 1px solid #eeeeee;
	}
	
	.head-title span {
		line-height: 30px;
		box-sizing: border-box;
		border-left: 2px solid #369eff;
		text-indent: 10px;
		padding-left: 10px;
	}
	
	.head-title .head-title-right {
		width: auto;
		min-width: 50px;
		height: 30px;
		box-sizing: border-box;
		text-align: right;
		display: inline-block;
		line-height: 30px;
		float: right;
		margin-top: 10px;
	}
</style>


// WEBPACK FOOTER //
// Title.vue?565258c3